import { z } from 'zod'
import { MailIcon } from 'lucide-react'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const email = {
  component: QuestionWrapper,
  name: 'textQuestion',
  coreIf: true, // Always core - final step
  componentProps: {
    title: 'Final Question! What is your email?',
    label: 'Email',
    textCollection: [
      {
        formValue: 'email',
        type: 'email',
        label: 'Email address',
        placeholder: 'Enter your email',
        icon: MailIcon,
      },
    ],
    tooltip: 'Get rates, exclusive deals, and energy-saving tips delivered straight to your inbox.',
    // canSkip: true,
  },
  schema: z.object({
    email: z.string().min(1, 'Email is required.').email('Invalid email format.'),
  }),
}
